/**
 * Validates if a value is a valid number
 * @param value Value to validate
 */
export const validateMetricValue = (value: string | number): boolean => {
  const numValue = typeof value === 'string' ? Number(value.replace(/[^0-9.-]/g, '')) : value;
  return !isNaN(numValue);
};

/**
 * Validates if a string is a valid email format
 * @param email Email to validate
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates password strength
 * @param password Password to validate
 */
export const validatePassword = (password: string): boolean => {
  // At least 8 characters, one uppercase, one lowercase, one number
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return passwordRegex.test(password);
};

/**
 * Validates if a URL is properly formatted
 * @param url URL to validate
 */
export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};